import { store } from '../../index';
import * as FromMainAppActions from '../actions/from-main-app';
import * as FromClientsFrontendActions from '../actions/from-client-frontend';
import AppEvents from '../constants/events';
import { on, trigger } from '../events-manager';
import { isSalesChatEnvironmentValid, validateMissingParam } from '../utils/params-validation';
import CONFIG from '../../../config';
import { CHAT_STATE } from '../../constants';
import { createChat } from '../../main';
import { getVisitorToken } from '../../selectors/chat-session';
import { shouldOpenNewChat } from '../utils/sales-chat-probability';
import { debugEvent } from '../../actions/debug';
import { getJwtBodyPart } from '../utils/jwt';
import { setOptions } from '../actions/from-main-app';

const DEFAULT_ENVIRONMENT = 'production';

export const initAppEventsWatchers = () => {
  on(AppEvents.SG_SITE_PAGE_LOADED, ({ environment = DEFAULT_ENVIRONMENT, language = 'en' }) => {
    validateMissingParam('environment', environment);

    if (!isSalesChatEnvironmentValid(environment)) {
      // TODO how to handle disabled chat button
      console.error('INVALID ENVIRONMENT');
      return;
    }

    const { IMPULSE_URLS, CHAT_API } = CONFIG.SALES_CHAT_CONFIGURATION_BY_SITE_ENV[environment];

    store.dispatch(
      FromClientsFrontendActions.storeSessionInfo({
        IMPULSE_URLS,
        CHAT_API,
        language
      })
    );

    const visitorToken = getVisitorToken(store.getState());

    if (visitorToken) {
      store.dispatch(FromClientsFrontendActions.initWebsocketUnAuthorized());

      on(AppEvents.CHAT_STARTED, createChat);
    }
  });

  on(
    AppEvents.START_CHAT_PRESALE,
    ({
      environment = DEFAULT_ENVIRONMENT,
      currency = null,
      promo = null,
      campaign = null,
      autoStart = null,
      popup = null,
      serviceCompanyId = null
    }) => {
      const state = store.getState();
      const language = state.chatSession.language;
      validateMissingParam('environment', environment);

      if (!isSalesChatEnvironmentValid(environment)) {
        console.error('INVALID ENVIRONMENT');
        return;
      }

      if (!shouldOpenNewChat({ environment })) {
        trigger(AppEvents.CANNOT_START_NEW_SALES_CHAT_DUE_TO_PROBABILITY);
        return;
      }

      createChat();

      if (autoStart) {
        return store.dispatch(
          FromClientsFrontendActions.requestLoginPresale({
            name: autoStart.name,
            email: autoStart.email,
            question: autoStart.question,
            referring_url: window.location.href,
            language,
            serviceCompanyId,
            onFailure: (response) => {
              if (!response.data || !response.data.error) {
                return;
              }

              if (response.data.error.busy) {
                store.dispatch(FromClientsFrontendActions.setChatStatus(CHAT_STATE.NO_AVAILABLE_OPERATOR));
              }

              if (response.data.error.chatting) {
                store.dispatch(FromClientsFrontendActions.setChatStatus(CHAT_STATE.CURRENTLY_CHATTING));
              }
            }
          })
        );
      }

      store.dispatch(FromClientsFrontendActions.setPromoParams({ currency, promo, serviceCompanyId }));
      store.dispatch(FromClientsFrontendActions.setChatStatus(CHAT_STATE.LOGIN_PRESALES));
      store.dispatch(FromClientsFrontendActions.setChatOpenedFrom({ campaign, popup }));
    }
  );

  on(AppEvents.START_CHAT_TECHNICAL, (parameters) => {
    validateMissingParam('assistance', parameters.assistance);
    validateMissingParam('client', parameters.client);
    validateMissingParam('inquiry', parameters.inquiry);
    validateMissingParam('support_init_question', parameters.support_init_question);

    store.dispatch(debugEvent({ name: 'START_CHAT_TECHNICAL' }));

    store.dispatch(FromMainAppActions.startChatTechnical(parameters));
  });

  on(AppEvents.START_CHAT_CANCELLATION, ({ client, cancellation, cur_code, local_phone, request_id }) => {
    validateMissingParam('client', client);
    validateMissingParam('cancellation', cancellation);
    validateMissingParam('cur_code', cur_code);
    validateMissingParam('local_phone', local_phone);
    validateMissingParam('request_id', request_id);

    store.dispatch(debugEvent({ name: 'START_CHAT_CANCELLATION' }));

    store.dispatch(
      FromMainAppActions.startChatCancellation({
        client,
        cancellation,
        cur_code,
        local_phone,
        request_id
      })
    );
  });

  on(AppEvents.CLIENT_TOKEN_UPDATED, ({ clientToken }) => {
    store.dispatch(
      debugEvent({
        name: 'CLIENT_TOKEN_UPDATED',
        payload: {
          clientToken: getJwtBodyPart({ token: clientToken })
        }
      })
    );

    validateMissingParam('clientToken', clientToken);

    store.dispatch(FromMainAppActions.clientTokenUpdated({ clientToken }));
  });

  on(AppEvents.INDICATE_CHAT_IS_ACTIVE, () => {
    store.dispatch(FromMainAppActions.indicateChatIsActive());
  });

  on(AppEvents.START_CHAT_AUTHENTICATED_INQUIRY, () => {
    store.dispatch(FromClientsFrontendActions.setChatStatus(CHAT_STATE.AUTHENTICATED_INQUIRY));
  });

  on(AppEvents.SET_CHAT_WINDOW_MINIMIZED, () => {
    store.dispatch(FromClientsFrontendActions.setChatMinimized(true));
  });

  on(AppEvents.SET_CHAT_WINDOW_IS_CLOSABLE, ({ isClosable }) => {
    store.dispatch(FromClientsFrontendActions.setIsChatWindowClosable(isClosable));
  });

  on(AppEvents.PREFILL_USER_DATA, ({ userNames, email }) => {
    store.dispatch(FromClientsFrontendActions.prefillUserData({ userNames, email }));
  });

  on(AppEvents.ON_SET_OPTIONS, (options) => {
    store.dispatch(setOptions(options));
  });
};
